<template>
<div class="custom-font">
    <FontInput
        :value="fontUrl"
        @input="$emit('update:fontUrl', $event)"
        :fontLoadingState="fontLoadingState">
        <template #label>Font URL</template>
        <!-- <template #help>
            <a :href="fontOrigin" target="_blank">More fonts</a>.
            Here's a <a :href="demoUrl" target="_blank">video tutorial</a>
            on how to add a font.
        </template> -->
    </FontInput>
</div>
</template>

<script>
import { mapState } from 'vuex'

import FontInput from '@/font-loader/FontInput'

const fontOrigin = 'https://fonts.google.com'

export default {
    name: 'ConfigFont',
    props: {
        fontUrl: String,
    },
    data: () => ({
        fontOrigin,
        demoUrl: 'https://youtu.be/frfESHqHzCI',
    }),
    computed: {
        ...mapState(['fontLoadingState']),
    },
    components: {
        FontInput,
    }
}
</script>

<style lang="scss" scoped>
.field.font-url {
    margin-bottom: 1rem;
}
</style>
